/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
Component: src/utils/randomColors.ts
*/

export const randomFillColor = () => {
  const x = Math.floor(Math.random() * 256);
  const y = Math.floor(Math.random() * 256);
  const z = Math.floor(Math.random() * 256);
  return `rgba(${x},${y},${z}, 0.8)`;
};

export const randomFillColorGrey = () => {
  const value = (Math.random() * 0xff) | 0;
  const grayscale = (value << 16) | (value << 8) | value;
  return '#' + grayscale.toString(16);
};
